import { StyledText } from "./styles";

interface LoadingTextProps {
  subject?: string;
}

const LoadingText = ({ subject }: LoadingTextProps) => {
  return (
    <StyledText className="p-[10px] text-center opacity-70">
      {subject ? `Loading ${subject}...` : "Loading"}
    </StyledText>
  );
};

export default LoadingText;
